import { useState } from 'react';
import { motion } from 'framer-motion';
import { LOOKBOOK } from './data';

// LOOKBOOK — print-folio layout. Filter by type, then a 2-up gatefold layout.
export default function Lookbook() {
  const types = ['All', ...new Set(LOOKBOOK.map(l => l.type))];
  const [t, setT] = useState('All');
  const list = t === 'All' ? LOOKBOOK : LOOKBOOK.filter(l => l.type === t);
  return (
    <div className="bg-[#E5DDCB] text-[#1F1E1B] relative">
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none" style={{ backgroundImage: 'linear-gradient(#1F1E1B 1px, transparent 1px), linear-gradient(90deg, #1F1E1B 1px, transparent 1px)', backgroundSize: '40px 40px' }} />
      <section className="relative pt-12 pb-10 max-w-[1500px] mx-auto px-8 lg:px-14 border-b border-[#1F1E1B]/15">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#6B2D2A] mb-4">— Folio II · Lookbook</p>
        <h1 className="font-serif text-[44px] sm:text-[72px] lg:text-[112px] leading-[0.92] tracking-[-0.02em]">A folio of <span className="italic text-[#6B2D2A]">recent work</span>.</h1>
      </section>

      {/* Filter rail */}
      <div className="relative border-b border-[#1F1E1B]/15 sticky top-16 bg-[#E5DDCB]/95 backdrop-blur-md z-30">
        <div className="max-w-[1500px] mx-auto px-8 lg:px-14 py-4 flex flex-wrap items-center gap-2 font-mono text-[10px] tracking-[0.22em] uppercase">
          <span className="text-[#1F1E1B]/45 mr-2">Type</span>
          {types.map(c => (
            <button key={c} onClick={() => setT(c)} data-testid={`tailor-type-${c}`}
              className={`px-3 py-1.5 transition-colors ${t === c ? 'bg-[#6B2D2A] text-[#E5DDCB]' : 'border border-[#1F1E1B]/20 text-[#1F1E1B]/65 hover:border-[#1F1E1B]/45'}`}>
              {c}
            </button>
          ))}
        </div>
      </div>

      {/* Gatefold spread */}
      <section className="relative max-w-[1500px] mx-auto px-8 lg:px-14 py-12 grid grid-cols-1 md:grid-cols-2 gap-8">
        {list.map((l, i) => (
          <motion.figure key={l.code} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.06 }}
            className="bg-[#FAF6E8] border border-[#1F1E1B]/15 group">
            <div className="aspect-[3/4] overflow-hidden">
              <img src={l.img} alt={l.t} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-1000" loading="lazy" />
            </div>
            <figcaption className="p-6 lg:p-8 grid grid-cols-[1fr_auto] gap-4 items-baseline border-t border-[#1F1E1B]/15">
              <div>
                <p className="font-mono text-[9px] tracking-[0.4em] uppercase text-[#6B2D2A]" dangerouslySetInnerHTML={{ __html: l.code }} />
                <p className="font-serif text-2xl mt-1.5 leading-tight" dangerouslySetInnerHTML={{ __html: l.t }} />
                <p className="font-serif italic text-base text-[#1F1E1B]/65 mt-2" dangerouslySetInnerHTML={{ __html: l.cloth }} />
                <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#1F1E1B]/45 mt-2">{l.ref}</p>
              </div>
              <span className="font-mono text-[10px] tracking-[0.3em] uppercase bg-[#6B2D2A] text-[#E5DDCB] px-2.5 py-1">{l.type}</span>
            </figcaption>
          </motion.figure>
        ))}
      </section>
    </div>
  );
}
